/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Hero_LeadInputs */

const en_dr_hero_lead = /** @type {(inputs: Dr_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before Bystep writes a PRD, your team, your client or your capstone advisor agree — in a structured room, not a blank whiteboard — on the problem, the users, and which hypothesis is worth testing first.`)
};

const id_dr_hero_lead = /** @type {(inputs: Dr_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelum Bystep menulis PRD, tim, klien, atau dosen pembimbing Anda menyepakati — di ruang terstruktur, bukan papan tulis kosong — apa masalahnya, siapa penggunanya, dan hipotesis mana yang layak diuji lebih dulu.`)
};

/**
* | output |
* | --- |
* | "Before Bystep writes a PRD, your team, your client or your capstone advisor agree — in a structured room, not a blank whiteboard — on the problem, the users,..." |
*
* @param {Dr_Hero_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_hero_lead = /** @type {((inputs?: Dr_Hero_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Hero_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_hero_lead(inputs)
	return en_dr_hero_lead(inputs)
});